const BASE_URL = "https://shopify-backend.minimeal.com/api/"
const BASE_PATH = window.ShopifyCustomer?.path || '';

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


async function checkQty(product_id, max_qty) {
    try {
        const cartRes = await fetch("/cart.js", { cache: "no-store" });
        const cart = await cartRes.json();

         // const lineItem = cart.items.find(item => Number(item.variant_id) === product_id);
         const lineItem = cart.items.find(function (item){

             if(item.variant_id==product_id){
                 return item.quantity;
             }
         });
        const currentQty = lineItem ? Number(lineItem.quantity) : 0;

        if (currentQty  >= Number(max_qty)) {
            showToast(`Dieses Produkt kann maximal nur [${max_qty}] x im Warenkorb bestellt werden.` , { title: 'Hinweis', type: 'warning', duration: 2000 });
            return true;
        }
        return false;
    } catch (e) {
        console.error('checkQty error', e);
        return false;
    }
}


window.addEventListener('DOMContentLoaded', function () {
    let items = document.querySelectorAll('.effectUp');

    items.forEach(function (box) {
        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    box.classList.add('animate');
                }
            });
        });

        observer.observe(box);
    });


    //logout
    let logoutBtn = document.querySelectorAll('.account-logout--btn');


    logoutBtn.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            
            let token = getCookie("bkend_tkn");
            if (token) {
                e.preventDefault();
                
                fetch(BASE_PATH + '/logout', {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                })
                .catch(err => {
                    console.error("Logout sync failed:", err);
                })
                .finally(() => {
                    document.cookie = "bkend_tkn=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
                    window.location.href = "/account/logout";
                });
            }
        });
    });


});


window.addEventListener('DOMContentLoaded', function () {
    let classList = document.querySelector('body').classList;

    document.querySelectorAll('.header-section--wrapper .js-drawer-open-right-link').forEach(function (el) {
        el.addEventListener('click', function () {

            if (!classList.contains('btn-gold-drawer-cart')) {
                classList.add('btn-gold-drawer-cart')
            }
        });
    });

    window.eventBus.on('close:cart:drawer', () => {
        classList.remove('btn-gold-drawer-cart')
    });
});


function getTokenApiSubscription() {
    const c = getCookie("bkend_tkn");
    if (c) return c;
    const meta = document.querySelector('meta[name="tkn"]');
    if (meta?.content) return meta.content;
    const htmlT = document.documentElement.getAttribute("data-tkn");
    return htmlT || null;
}

// async function hasActiveSubscription() {

//     if(!isLogin()){
//         return false ;
//     }

//     try {
//         const tkn = getTokenApiSubscription();
//         const res = await fetch(BASE_URL+'customer/check-active-subscription', {
//             method: "POST",
//             headers: {"Content-Type": "application/json"},
//             credentials: "omit",
//             body: JSON.stringify({token: tkn})
//         });
//         if (!res.ok) {
//             return true;
//         }
//         const data = await res.json().catch(() => ({}));

//         return (data?.status) && (data?.subscriptionStatus);
//      } catch (e) {
//         console.log("check error -> treat as active", e);
//         return true;
//     }
// }

// ==== Guard for Shopify add-to-cart — single-run per attempt ====
// prereq: BASE_URL, hasActiveSubscription(), getTokenApiSubscription(), showConfirmYesNo()

// (() => {
//     const FORM_SEL = 'form.shopify-product-form.check-active-subscription';
//     if (window.__chkSubInstalled) return;
//     window.__chkSubInstalled = true;

//      const guarding = new WeakSet();
//     let bypassOnce = false;

//     async function runGuardOnce(form) {
//         if (guarding.has(form)) return;
//         guarding.add(form);
//         try {
//             const active = await hasActiveSubscription();
//             if (!active) {
//                 bypassOnce = true;
//                 HTMLFormElement.prototype.submit.call(form);
//                 bypassOnce = false;
//                 return;
//             }

//             const tkn = getTokenApiSubscription();
//             showConfirmYesNo(
//                 'Aktives Abonnement',
//                 'Sie haben ein aktives Abonnement. Möchten Sie es kündigen?',
//                 async ({ modalMessage }) => {
//                     try {
//                         const res = await fetch(BASE_URL + 'customer/cancel-subscription', {
//                             method: 'POST',
//                             headers: { 'Content-Type': 'application/json' },
//                             credentials: 'omit',
//                             body: JSON.stringify({ token: tkn, source: 'cart_block_modal' })
//                         });
//                         const payload = await res.json().catch(() => ({}));
//                         if (!res.ok) {
//                             modalMessage.innerText = 'Cancel failed: ' + (payload.message || res.status);
//                             return;
//                         }
//                         modalMessage.innerText = 'Cancel success: ' + (payload.message || res.status);

//                         setTimeout(() => {
//                             bypassOnce = true;
//                             window.location.reload();
//                             // HTMLFormElement.prototype.submit.call(form);
//                             bypassOnce = false;
//                         }, 600);
//                     } catch (err) {
//                         modalMessage.innerText = 'Cancel error: ' + (err?.message || err);
//                     }
//                 },
//                 () => {},
//                 ''
//             );
//         } finally {
//             setTimeout(() => guarding.delete(form), 1500);
//         }
//     }

//      function interceptPointer(ev) {
//         window.addEventListener(ev, function (e) {
//             const btn = e.target.closest('button[type="submit"], input[type="submit"]');
//             if (!btn) return;
//             const form = btn.form || btn.closest('form');
//             if (!form || !form.matches(FORM_SEL)) return;
//             if (bypassOnce) return;

//              e.preventDefault();
//             e.stopImmediatePropagation();
//             e.stopPropagation();

//             runGuardOnce(form);
//         }, { capture: true, passive: false });
//     }
//     ['pointerdown','mousedown','touchstart','click'].forEach(interceptPointer);

//      window.addEventListener('submit', function (e) {
//         const form = e.target;
//         if (!(form instanceof HTMLFormElement)) return;
//         if (!form.matches(FORM_SEL)) return;
//         if (bypassOnce) return;

//         e.preventDefault();
//         e.stopImmediatePropagation();
//         e.stopPropagation();

//         runGuardOnce(form);
//     }, { capture: true });

//     const _fetch = window.fetch;
//     window.fetch = function(input, init) {
//         try {
//             const url = typeof input === 'string' ? input : input?.url;
//             const method = (init && init.method) || 'GET';
//             if (url && /\/cart\/add(\.js)?/i.test(url) && method.toUpperCase() !== 'GET' && !bypassOnce) {
//                  const activeEl = document.activeElement;
//                 const form = (activeEl?.form) || activeEl?.closest?.('form') || document.querySelector(FORM_SEL);

//                 if (form && form.matches(FORM_SEL)) {
//                     if (guarding.has(form)) {
//                          return Promise.resolve(new Response(null, { status: 204, statusText: 'Blocked by guard' }));
//                     }
//                      runGuardOnce(form);
//                     return Promise.resolve(new Response(null, { status: 204, statusText: 'Blocked by guard' }));
//                 }
//             }
//         } catch (_) {}
//         return _fetch.apply(this, arguments);
//     };

//      function wrapNewForms() {
//         document.querySelectorAll(FORM_SEL).forEach(f => {
//         });
//     }
//     wrapNewForms();
//     new MutationObserver(wrapNewForms).observe(document.body, { childList: true, subtree: true });
// })();

 let ignoreCheckSubscription = false;

 function isLogin(){
    return window.ShopifyCustomer && window.ShopifyCustomer.logged_in === true;
 }

// document.querySelectorAll('.check-active-subscription').forEach(btn => {
//     btn.addEventListener('click', async function (e) {

//         if(ignoreCheckSubscription){
//             return;
//         }
//         e.stopImmediatePropagation();
//         e.preventDefault();
//         const isLink = btn.tagName === 'A';
//         const href = isLink ? btn.getAttribute('href') : null;
//         const form = btn.form || btn.closest('form');

//          const active = await hasActiveSubscription();

//         if (active) {
//             const tkn = getTokenApiSubscription();

//             showConfirmYesNo(
//                 "Aktives Abonnement",
//                 "Sie haben ein aktives Abonnement. Möchten Sie es kündigen?",
//                 async function onYes(modalRefs) {
//                      const { modalMessage } = modalRefs;
//                     try {
//                         const res = await fetch(BASE_URL + "customer/cancel-subscription", {
//                             method: "POST",
//                             headers: {"Content-Type": "application/json"},
//                             credentials: "omit",
//                             body: JSON.stringify({ token: tkn, source: "cart_block_modal" })
//                         });

//                         if (!res.ok) {
//                             const txt = await res.json().catch(() => ({}));
//                             modalMessage.innerText = "Cancel failed: " + (txt.message || res.status);
//                             return;
//                         }

//                         const okTxt = await res.json().catch(() => ({}));
//                         modalMessage.innerText = "Cancel success: " + (okTxt.message || res.status);


//                         setTimeout(() => {
//                             if (isLink && href) {
//                                 window.location.href = href;
//                             } else if (form) {
//                                 form.submit();
//                             } else {
//                                 btn.click();
//                             }
//                         }, 1000);

//                     } catch (err) {
//                         modalMessage.innerText = "Cancel error: " + (err?.message || err);
//                     }
//                 },
//                 function onNo() {

//                 },
//                 ""
//             );
//         }else {
//             btn.click();
//             ignoreCheckSubscription = true;
//         }
//     },{capture: true});
// });

function showConfirmYesNo(title, description, callbackYes, callbackNo, message = "") {
    const overlay = document.createElement('div');
    overlay.className = 'ch-modal-overlay';

    const modal = document.createElement('div');
    modal.className = 'ch-modal-box';

    const modalTitle = document.createElement('div');
    modalTitle.className = 'ch-modal-title';
    modalTitle.innerText = title;

    const modalDesc = document.createElement('div');
    modalDesc.className = 'ch-modal-desc';
    modalDesc.innerHTML = description;

    const modalMessage = document.createElement('div');
    modalMessage.className = 'ch-modal-message';
    modalMessage.innerText = message || "";

    const buttons = document.createElement('div');
    buttons.className = 'ch-modal-buttons';

    const yesBtn = document.createElement('button');
    yesBtn.className = 'ch-btn-yes';
    yesBtn.innerText = 'Yes';

    const noBtn = document.createElement('button');
    noBtn.className = 'ch-btn-no';
    noBtn.innerText = 'No';

    buttons.appendChild(yesBtn);
    buttons.appendChild(noBtn);

    modal.appendChild(modalTitle);
    modal.appendChild(modalDesc);
    modal.appendChild(modalMessage);
    modal.appendChild(buttons);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    yesBtn.onclick = function () {
        document.body.removeChild(overlay);
        if (callbackYes) callbackYes({ modal, modalMessage });
    };

    noBtn.onclick = function () {
        document.body.removeChild(overlay);
        if (callbackNo) callbackNo();
    };
}


function showConsultMessage(uri) {

    showConfirmYesNo(
        "Consent Status",
        "Indem Sie auf „Yes“ klicken, stimmen Sie unseren <a target='_blank' style='text-decoration: underline; font-weight: bold' href='https://minimeal.com/pages/unsere-agb-1'>Nutzungsbedingungen</a> und <a style='text-decoration: underline; font-weight: bold;' target='_blank' href='https://minimeal.com/pages/datenschutzerklarung'>Datenschutzrichtlinien</a> zu, die es uns ermöglichen, Ihre persönlichen Daten zu erfassen und zu verwenden, um Ihnen Zugang zu unseren Diensten zu ermöglichen.",
        async function () {
            try {
                const token = getTokenApiSubscription();

                const res = await fetch(BASE_PATH + '/update-community-consent', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token}` },
                    credentials: "omit"
                });

                const data = await res.json();

                if (res.ok && data?.status) {
                    goToConsult(uri);
                } else {
                    const message = data?.message;
                    showToast(message || "Zustimmung konnte nicht aktualisiert werden.", { type: 'error', duration: 5000 });
                }
            } catch (e) {
                console.error("Consent update error:", e);
                showToast("Fehler beim Speichern der Zustimmung.", { type: 'error', duration: 5000 });
            }
        },
        function () {
         }
    );
}

async function goToConsult(uri) {
    // Open immediately — this must be synchronous
    const newTab = window.open('', '_blank');

    try {
        const token = getTokenApiSubscription();

        let res = await fetch(BASE_PATH + uri, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token}` },
            credentials: "omit",
        });

        const data = await res.json().catch(() => ({}));

        if (res.ok && data.status) {
            showToast(data.message, {title: 'HINWEIS', type: 'info', duration: 5000});

            // navigate already-opened tab
            if (newTab) {
                newTab.location.href = data.url;
            } else {
                // fallback if blocked
                window.location.href = data.url;
            }

        } else {
            showToast(
                "Diese Sitzung oder der generierte Session-Token zu einer der Komponenten wurde aus Sicherheitsgründen beendet, bzw. ist abgelaufen. Bitte logge dich aus und melde dich erneut an.",
                {title: 'HINWEIS:', type: 'error', duration: 5000}
            );

            // close blank tab if opened
            if (newTab) newTab.close();
        }

    } catch (e) {
        console.error(e, uri);
        if (newTab) newTab.close();
    }
}


window.addEventListener('DOMContentLoaded', function () {

    async function hasActiveConsent() {
        try {
            const token = getTokenApiSubscription();
            const res = await fetch(BASE_PATH + "/check-active-community", {
                method: "POST",
                headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
                credentials: "omit",
            });
            if (!res.ok) return true;
            const data = await res.json().catch(() => ({}));
            return !(data.status && data.communityConsentStatus);
        } catch (ex) {
            return true;
        }
    }

    // Community Dashboard
    document.querySelectorAll('.community_dashboard').forEach(el => {
        el.addEventListener('click', async e => {
            e.preventDefault();
            e.stopPropagation();
            if (await hasActiveConsent()) {
                showConsultMessage('/get-community-url');
            } else {
                goToConsult('/get-community-url');
            }
        });
    });

    // Soil Dashboard
    document.querySelectorAll('.soil_dashboard').forEach(el => {
        el.addEventListener('click', async e => {
            e.preventDefault();
            e.stopPropagation();
            // if (await hasActiveConsent()) {
            //     showConsultMessage('/get-access-dashboard');
            // } else {
                goToConsult('/get-access-dashboard');
            // }
        });
    });
});

// // customer menu toggle
(function () {
    const popover = document.getElementById('account-popover');
    const triggers = Array.from(document.querySelectorAll('[aria-controls="account-popover"]'));
    
    if (!popover || triggers.length === 0) return;
    
    let isOpen = false;
    let movedToBody = false;
    let lastTrigger = null;
    
    function setAriaAll(expanded) {
        triggers.forEach(t => t.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    }
    
    function positionPopover(trigger) {
        // ensure popover is in the DOM (we'll append to body once)
        if (!movedToBody) {
            document.body.appendChild(popover);
            movedToBody = true;
            // ensure popover uses absolute positioning
            popover.style.position = 'absolute';
            popover.style.zIndex = 10000;
        }
        
        // compute coordinates
        const rect = trigger.getBoundingClientRect();
        const popWidth = popover.offsetWidth || 220; // fallback
        const popHeight = popover.offsetHeight || 200; // fallback
        
        // default: place below trigger with small offset
        let top = rect.bottom + window.scrollY + 8;
        let left = rect.left + window.scrollX;
        
        // keep inside viewport horizontally
        if (left + popWidth + 8 > window.innerWidth) {
            left = Math.max(8, window.innerWidth - popWidth - 8);
        }
        if (left < 8) left = 8;
        
        // if not enough space below, try placing above
        if (top + popHeight + 8 > window.scrollY + window.innerHeight) {
            const aboveTop = rect.top + window.scrollY - popHeight - 8;
            if (aboveTop > 8) top = aboveTop;
        }
        
        popover.style.top = `${Math.round(top)}px`;
        popover.style.left = `${Math.round(left)}px`;
    }
    
    function openMenu(trigger) {
        lastTrigger = trigger;
        popover.hidden = false;
        setAriaAll(true);
        positionPopover(trigger);
        isOpen = true;
    }
    
    function closeMenu() {
        popover.hidden = true;
        setAriaAll(false);
        isOpen = false;
    }
    
    function toggleHandler(e) {
        e.preventDefault();
        const trigger = e.currentTarget;
        if (popover.hidden) openMenu(trigger);
        else closeMenu();
    }
    
    // attach listeners to all triggers
    triggers.forEach(t => {
        t.addEventListener('click', toggleHandler);
        // optional: reposition on focus/keyboard open
        t.addEventListener('keydown', (ev) => {
            if (ev.key === 'Enter' || ev.key === ' ') {
                ev.preventDefault();
                toggleHandler.call(t, ev);
            }
        });
    });
    
    // click outside to close
    document.addEventListener('click', (e) => {
        if (!isOpen) return;
        
        const clickedInsidePopover = popover.contains(e.target);
        const clickedOnTrigger = triggers.some(t => t.contains(e.target));
        if (!clickedInsidePopover && !clickedOnTrigger) closeMenu();
    });
    
    // reposition on resize/scroll when open
    window.addEventListener('resize', () => {
        if (isOpen && lastTrigger) positionPopover(lastTrigger);
    });
    window.addEventListener('scroll', () => {
        if (isOpen && lastTrigger) positionPopover(lastTrigger);
    }, { passive: true });
    
    // escape to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen) closeMenu();
    });
})();


function setShareIdToCart(share_id) {
    if (!share_id) return;

    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes: {
                share_id: share_id
            }
        })
    }).catch(function(e) {
        console.error('Failed to set share_id attribute', e);
    });
}

function setBkendTokenToCart(token) {
    if (!token) return;

    fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            attributes: {
                bkend_token: token
            }
        })
    }).catch(function(e) {
        console.error('Failed to set bkend_token attribute', e);
    });
}

function syncShareIdAttribute() {
    try {
        const params = new URLSearchParams(window.location.search);
        const queryShareId = params.get('share_id');
        if (queryShareId) {
            document.cookie = 'share_id=' + encodeURIComponent(queryShareId) + '; path=/; SameSite=Lax; max-age=' + (60 * 60 * 24 * 365);
        }

        const match = document.cookie.match(/(?:^|; )share_id=([^;]+)/);
        if (!match) return;

        const shareId = decodeURIComponent(match[1] || '');
        if (!shareId || window.__shareIdSynced) return;
        window.__shareIdSynced = true;

        setShareIdToCart(shareId);

        document.querySelectorAll('[data-share-id-input], input[name="attributes[share_id]"]').forEach((input) => {
            if (input && !input.value) input.value = shareId;
        });
    } catch (err) {
        console.error('share_id sync error', err);
    }
}

document.addEventListener('DOMContentLoaded', syncShareIdAttribute);
